import { Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { ChartOptions } from "./contract-control-economics-graph.component";
import { IEconomicChart } from "./contract-control-economics.dto";
import { GlobalService } from "app/global/global.service";
import { NumberFormatPipe } from "app/pipes/number-format.pipe";

import { ICompanySettingDTO } from "app/main/pages/settings/company/company-settings.dto";

@Injectable({
    providedIn: 'root'
})


export class ContractControlEconomicsService {

    constructor (
        private _translocoService: TranslocoService,
        private _globalService: GlobalService,
        private numberFormat: NumberFormatPipe
    ) {}

    getEconomicsData(chartData: IEconomicChart[], settings?: ICompanySettingDTO) {
        const safeData = chartData ?? [];
        const numberFormat = this.numberFormat;
        const allValues: number[] = safeData.reduce((acc, d) => {
            acc.push(Number(d.cost) || 0);
            acc.push(Number(d.revenue) || 0);
            return acc;
        }, [] as number[]);
        const maxValue = Math.max(...allValues);
        const yMax = maxValue === 0 ? 100 : maxValue * 1.2;
        return {
            series: [
                {
                    name: this._translocoService.translate('Contract control economic chart tooltip text (Contract control economic chart) - Contracted cost'),
                    data: safeData.map(d => Math.round(Number(d.cost) || 0))
                },
                {
                    name: this._translocoService.translate('Contract control economic chart tooltip text (Contract control economic chart) - Contracted revenue'),
                    data: safeData.map(d => Math.round(Number(d.revenue) || 0))
                }
            ],
            chart: {
                height: 200,
                type: "area",
                toolbar: { 
                    show: false 
                },
                zoom: { 
                    enabled: false
                }
            },
            dataLabels: { 
                enabled: false 
            },
            stroke: {
                curve: "smooth",
                width: 0
            },
            colors: ["#7E57C2", "#B39DDB"],
            fill: {
                type: "solid",
                colors: ["#7E57C2", "#B39DDB"],
                opacity: 0.4
            },
            grid: { show: false },
            legend: { show: false },
            xaxis: {
                categories: safeData.map(d => d.month),
                labels: { show: false },
                axisTicks: { show: false },
                axisBorder: { show: false },
                tooltip: { enabled: false }
            },
           yaxis: {
                min: 0,
                max: yMax,
                show: true,
                showAlways: true,
                labels: { show: false }
            },
            tooltip: {
                theme: "dark",
                custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                    const d = safeData[dataPointIndex] || { month: '', cost: '', revenue: '' };
                    return `
                        <div style="padding:8px; text-align:left; font-family:sans-serif;">
                            <div style="font-weight:600; margin-bottom:4px;">${d.month}</div>
                            <div>${this._translocoService.translate('Contract control economic chart tooltip text (Contract control economic chart) - Contracted cost')}:&nbsp;<b>${numberFormat.transform(Number(d.cost), true, true, settings)}</b></div>
                            <div>${this._translocoService.translate('Contract control economic chart tooltip text (Contract control economic chart) - Contracted revenue')}:&nbsp;<b>${numberFormat.transform(Number(d.revenue), true, true, settings)}</b></div>
                        </div>
                    `;
                }
            }
        };
    }
}